/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createLog1p } from '../../factoriesNumber.js';
export var log1pDependencies = {
  typedDependencies,
  createLog1p
};